import React, { memo } from 'react';
import { 
  AlertCircle, 
  ArrowLeft, 
  Check, 
  ChevronDown, 
  ChevronUp, 
  Clock, 
  Download, 
  Edit, 
  Eye, 
  EyeOff, 
  FileText, 
  Glasses, 
  Home, 
  Info, 
  Loader, 
  Lock, 
  LogOut, 
  Mail, 
  Menu, 
  MessageSquare, 
  Minus, 
  Package, 
  Plus, 
  RefreshCw, 
  Save, 
  Search, 
  Send, 
  Settings, 
  Star, 
  Trash, 
  User, 
  X,
  AlertTriangle,
  BarChart2,
  BarChart3,
  DollarSign
} from 'lucide-react';
import type { LucideProps } from 'lucide-react';

// Map of icon names to components
const iconMap: Record<string, React.ComponentType<LucideProps>> = {
  alertCircle: AlertCircle,
  alertTriangle: AlertTriangle,
  arrowLeft: ArrowLeft,
  barChart2: BarChart2,
  barChart3: BarChart3,
  check: Check,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  clock: Clock,
  dollarSign: DollarSign,
  download: Download,
  edit: Edit,
  eye: Eye,
  eyeOff: EyeOff,
  fileText: FileText,
  glasses: Glasses,
  home: Home,
  info: Info,
  loader: Loader,
  lock: Lock,
  logout: LogOut,
  mail: Mail,
  menu: Menu,
  messageSquare: MessageSquare,
  minus: Minus,
  package: Package,
  plus: Plus,
  refreshCw: RefreshCw,
  save: Save,
  search: Search,
  send: Send,
  settings: Settings,
  star: Star,
  trash: Trash,
  user: User,
  x: X
};

export type IconName = keyof typeof iconMap;

interface DynamicIconProps extends Omit<LucideProps, 'ref'> {
  name: string;
  size?: number;
}

export const DynamicIcon: React.FC<DynamicIconProps> = memo(({
  name,
  size = 24,
  ...props
}) => {
  // Get the icon component from the map
  const IconComponent = iconMap[name as IconName];

  // If the icon doesn't exist, show a fallback
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return (
      <div 
        className="inline-block bg-gray-200 rounded"
        style={{ width: size, height: size }}
        {...props}
      />
    );
  }

  // Render the icon
  return <IconComponent size={size} {...props} />;
});

DynamicIcon.displayName = 'DynamicIcon';